
    import { Options, Vue } from 'vue-class-component';
    import { faStar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

    @Options({
        components:{
            FontAwesomeIcon
        },
      props: {
        rate: Number,
        totalReviews: Number,
      }
    })
    export default class StarRating extends Vue {
        rate!: number
        totalReviews!: number
        starIcon=faStar
    }
    